export enum ConstantsApiMethods {
    getCurrencies = "ConstantsRegistry.GetCurrencies",
    getLocales = "ConstantsRegistry.GetLocales",
    getMeasurementUnits = "ConstantsRegistry.GetMeasurementUnits",
    getOrderPaymentDetailsTypes = "ConstantsRegistry.GetOrderPaymentDetailsTypes",
    getPaymentProvidersTypes = "ConstantsRegistry.GetPaymentProvidersTypes",
    getReportingDestinationTypes = "ConstantsRegistry.GetReportingDestinationTypes",
    getDeliveryTypes = "ConstantsRegistry.GetDeliveryTypes",


}
